import { createFileRoute, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import ClientDetailPage, { pathToClientDetailTab } from "@/components/settings/clients/client-detail-page";

const ClientDetailLayout = (): JSX.Element => {
	const { id } = Route.useParams();
	const pathname = useRouterState({ select: (state) => state.location.pathname });
	const tab = pathToClientDetailTab(pathname, id) ?? "edit";
	return <ClientDetailPage clientId={id} tab={tab} />;
};

export const Route = createFileRoute("/_app/settings/clients/$id")({
	component: ClientDetailLayout,
});
